export default (activeCategory) => ({
    activeCategory: activeCategory,
    results: false,
    init() {

    }
})